var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SiteApi } from "../siteApi";
import { CLASS_NAMES, LOCAL_PRIVACY_UPDATE_POP, POP_BOX_ID } from "./const";
import { renderPrivacyPop } from "./dom";
var PrivacyUpdatePop = /** @class */ (function () {
    function PrivacyUpdatePop(options) {
        this.language = "en-US";
        this.needUpdatePop = false;
        if (typeof options !== "object") {
            return;
        }
        this.options = Object.assign({}, options);
        this._init();
    }
    // 请求内容站点获取链接
    PrivacyUpdatePop.prototype._initSiteApi = function (siteConfig, language) {
        var _a, _b, _c;
        if (language === void 0) { language = 'en-US'; }
        return __awaiter(this, void 0, void 0, function () {
            var appId, region, website, page, block, channel, siteResp, updateDate, nowDate, updateDuration, localCache;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        appId = siteConfig.appId, region = siteConfig.region, website = siteConfig.website, page = siteConfig.page, block = siteConfig.block, channel = siteConfig.channel;
                        if (!this._siteApi) {
                            this._siteApi = new SiteApi({
                                appId: appId,
                                region: region,
                                language: language,
                            });
                        }
                        return [4 /*yield*/, this._siteApi.getNews({
                                website: website,
                                page: page,
                                block: block,
                                channel: channel,
                                language: language,
                            })];
                    case 1:
                        siteResp = _d.sent();
                        this.privacyUrl = ((_a = siteResp === null || siteResp === void 0 ? void 0 : siteResp[0]) === null || _a === void 0 ? void 0 : _a.url) || "";
                        this.privacyContent = ((_b = siteResp === null || siteResp === void 0 ? void 0 : siteResp[0]) === null || _b === void 0 ? void 0 : _b.description) || "";
                        updateDate = (_c = siteResp === null || siteResp === void 0 ? void 0 : siteResp[0]) === null || _c === void 0 ? void 0 : _c.update_at;
                        nowDate = Math.floor(Date.now() / 1000);
                        updateDuration = 30 * 24 * 60 * 60;
                        localCache = localStorage.getItem(LOCAL_PRIVACY_UPDATE_POP);
                        if (nowDate > updateDate && nowDate - updateDate < updateDuration && !localCache) {
                            this.needUpdatePop = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // 渲染弹窗内容
    PrivacyUpdatePop.prototype._render = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var _e, language, siteConfig, popBoxDom;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _e = this.options, language = _e.language, siteConfig = _e.siteConfig;
                        if (!siteConfig || typeof siteConfig !== "object") {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._initSiteApi(siteConfig, language)];
                    case 1:
                        _f.sent();
                        if (!this.needUpdatePop) {
                            (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.onInit) === null || _b === void 0 ? void 0 : _b.call(_a, this);
                            return [2 /*return*/];
                        }
                        popBoxDom = document.querySelector("#".concat(POP_BOX_ID));
                        if (!popBoxDom) {
                            popBoxDom = document.createElement('div');
                            popBoxDom.id = POP_BOX_ID;
                            document.body.appendChild(popBoxDom);
                        }
                        popBoxDom.innerHTML = renderPrivacyPop({
                            language: language,
                            url: this.privacyUrl,
                            content: this.privacyContent,
                        });
                        this._addEvent();
                        (_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.onInit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
                        return [2 /*return*/];
                }
            });
        });
    };
    // 添加事件
    PrivacyUpdatePop.prototype._addEvent = function () {
        var buttonDom = document.querySelector('#privacy-update-pop-button');
        var containerDom = document.querySelector('#privacy-update-pop-container');
        if (!containerDom.className.includes(CLASS_NAMES.activeContainer)) {
            containerDom.classList.add(CLASS_NAMES.activeContainer);
        }
        var closePop = function () {
            containerDom.classList.remove(CLASS_NAMES.activeContainer);
            localStorage.setItem(LOCAL_PRIVACY_UPDATE_POP, '1');
        };
        buttonDom.addEventListener('click', closePop);
    };
    PrivacyUpdatePop.prototype._init = function () {
        this._render();
    };
    return PrivacyUpdatePop;
}());
export { PrivacyUpdatePop };
//# sourceMappingURL=index.js.map